module.exports = __webpack_public_path__ + "images/backgrounds/mountain/small.da8d70dd70d666361767.jpg";